import { appConstants } from './app/AppConstants';
import { funnelConstants } from './funnel/FunnelConstants';
import { paymentsConstants } from './payments/PaymentsConstants';

export const constants = {
  app: appConstants,
  funnel: funnelConstants,
  payments: paymentsConstants,
};
